module.exports = __webpack_public_path__ + "img/api-economy-connector-2.6c16e392.svg";